import api from './api';

export const rateService = {
  // Obtener todas las tarifas (super admin ve todas, club solo las suyas)
  getRates: async () => {
    const response = await api.get('/rates');
    return response.data;
  },

  // Obtener una tarifa específica
  getRate: async (id) => {
    const response = await api.get(`/rates/${id}`);
    return response.data;
  },

  // Crear una nueva tarifa
  createRate: async (rateData) => {
    const response = await api.post('/rates', rateData);
    return response.data;
  },

  // Actualizar una tarifa
  updateRate: async (id, rateData) => {
    const response = await api.put(`/rates/${id}`, rateData);
    return response.data;
  },

  // Eliminar una tarifa
  deleteRate: async (id) => {
    const response = await api.delete(`/rates/${id}`);
    return response.data;
  }
};
